export default __webpack_public_path__ + "static/hall-515c4f0726d664fa14e4318899ff05d8.jpg";